import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Input,
  OnChanges,
} from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { HttpClient } from "@angular/common/http";

import { MENU } from "./menu";
import { MenuItem } from "./menu.model";
import { TranslateService } from "@ngx-translate/core";
import { AuthenticationService } from "src/app/core/services/auth.service";
import { AuthfakeauthenticationService } from "src/app/core/services/authfake.service";
import { EventService } from "src/app/core/services/event.service";
import { environment } from "src/environments/environment";
import MetisMenu from "metismenujs";

@Component({
  standalone: false,
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild("componentRef") scrollRef!: any;
  @Input() isCondensed = false;
  menu: any;
  data: any;
  profile: any;
  version: string = environment.version;

  menuItems: MenuItem[] = [];

  @ViewChild("sideMenu") sideMenu!: ElementRef;

  constructor(
    private eventService: EventService,
    private router: Router,
    public translate: TranslateService,
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService,
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
        this._scrollElement();
      }
    });
  }

  ngOnInit() {
    this.initialize();
    this._scrollElement();
    this.getUser();

    this.translate.onLangChange.subscribe(() => {
      this.initialize();
    });
  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
  }

  toggleMenu(event: Event) {
    (event.currentTarget as HTMLElement).nextElementSibling?.classList.toggle(
      "mm-show",
    );
  }

  ngOnChanges() {
    if ((!this.isCondensed && this.sideMenu) || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }

  _scrollElement() {
    setTimeout(() => {
      const activeEls = document.getElementsByClassName("mm-active");
      if (activeEls.length > 0) {
        const currentPosition = (activeEls[0] as HTMLElement).offsetTop;
        if (currentPosition > 500 && this.scrollRef?.SimpleBar) {
          this.scrollRef.SimpleBar.getScrollElement().scrollTop =
            currentPosition + 300;
        }
      }
    }, 300);
  }

  _removeAllClass(className: string) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  _activateMenuDropdown() {
    this._removeAllClass("mm-active");
    this._removeAllClass("mm-show");
    const links = document.getElementsByClassName("side-nav-link-ref");
    let menuItemEl: Element | null = null;

    const paths: string[] = [];
    for (let i = 0; i < links.length; i++) {
      paths.push((links[i] as HTMLAnchorElement).pathname);
    }

    let itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf("/");
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)] ?? null;
    } else {
      menuItemEl = links[itemIndex] ?? null;
    }

    if (menuItemEl) {
      menuItemEl.classList.add("active");
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add("mm-active");
        const parent2El = parentEl.parentElement?.closest("ul");
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.add("mm-show");
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== "side-menu") {
            parent3El.classList.add("mm-active");
            const childAnchor = parent3El.querySelector(".has-arrow");
            const childDropdown = parent3El.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== "side-menu") {
              parent4El.classList.add("mm-show");
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== "side-menu") {
                parent5El.classList.add("mm-active");
                const childanchor = parent5El.querySelector(".is-parent");
                if (childanchor && parent5El.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  }

  initialize(): void {
    const user = this.authenticationService.currentUser();
    const userRole = user?.profileWkf;

    // ADMINISTRATOR é super-usuário: enxerga todos os itens do menu,
    // ignorando o profilesAllowed (inclusive itens futuros).
    const isAdministrator = userRole === "ADMINISTRATOR";

    this.menuItems = MENU.filter(
      (item) =>
        isAdministrator ||
        !item.profilesAllowed ||
        item.profilesAllowed.includes(userRole)
    ).map((item: MenuItem) => ({
      ...item,
      label: this.translate.instant(item.label ?? ""),
      subItems: item.subItems
        ? item.subItems
            .filter(
              (sub: any) =>
                isAdministrator ||
                !sub.profilesAllowed ||
                sub.profilesAllowed.includes(userRole)
            )
            .map((sub: MenuItem) => ({
              ...sub,
              label: this.translate.instant(sub.label ?? ""),
            }))
        : [],
    }));
  }

  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  getUser() {
    var user = this.authFackservice.getUser();
    this.profile = user?.profile?.code;
  }
}
